import { CHANNEL_CONFIG } from "@/config/constConfig";
import { accDiv, accMul } from "./math";
import { currentChannel } from "@/config/config";

let channel = currentChannel.channel;

/** 
 * 转换金额
 * @param gold: 金额,以分为单位
*/
export function changeMoney(gold: number): string {
    gold = gold ? gold : 0
    if (channel == CHANNEL_CONFIG.BR) {  //巴西货币(雷尔)
        return changeMoneyByBRL(gold);
    } else if (channel == CHANNEL_CONFIG.ID) {  //印尼(卢比)
        return changeMoneyByID(gold);
    } else if (channel == CHANNEL_CONFIG.MX) {  //墨西哥(比索)
        return changeMoneyByMX(gold);
    } else if (channel == CHANNEL_CONFIG.PH) {  //菲律宾(比索)
        return changeMoneyByPHP(gold);
    } else if (channel == CHANNEL_CONFIG.VN) {  //越南(越南盾)
        return changeMoneyByVND(gold);
    } else if (channel == CHANNEL_CONFIG.TH) {  //泰国(泰铢)
        return changeMoneyByTHB(gold);
    } else if (channel == CHANNEL_CONFIG.EG) {  //埃及(埃镑)
        return changeMoneyByEGP(gold);
    } else if (channel == CHANNEL_CONFIG.CO) {  //哥伦比亚(比索)
        return changeMoneyByCOP(gold);
    } else if (channel == CHANNEL_CONFIG.IN) {  //印度(卢比)
        return changeMoneyByIN(gold);
    }
    return "";
};

/**获取带货币符号的金额 */
export function getGold(gold: number) {
    return currentChannel.currencyGold + changeMoney(gold);
}

/**
 * 获取转换后的金额 纯数字
 * */
export function changeAmount(amount: number): number {
    if (channel == CHANNEL_CONFIG.BR) { //巴西货币(雷尔)
        return accDiv(amount, 100);
    } else if (channel == CHANNEL_CONFIG.ID) {  //印尼(卢比)
        return accMul(amount, 10);
    } else if (channel == CHANNEL_CONFIG.MX) {  //墨西哥(比索)
        return amount;
    } else if (channel == CHANNEL_CONFIG.PH) {  //菲律宾(比索)
        return accDiv(amount, 100);
    } else if (channel == CHANNEL_CONFIG.VN) {  //越南(越南盾)
        return amount;
    } else if (channel == CHANNEL_CONFIG.TH) {  //泰国(泰铢)
        return accDiv(amount, 100);
    } else if (channel == CHANNEL_CONFIG.EG) {  //埃及(埃镑)
        return accDiv(amount, 100);
    } else if (channel == CHANNEL_CONFIG.CO) {  //哥伦比亚(比索)
        return amount;
    } else if (channel == CHANNEL_CONFIG.IN) {  //印度(卢比)
        return accDiv(amount, 100);
    }
    return 0;
}

/**
 * 获取转换后的金额 纯数字
 * */
export function changeTimeNum(timeNum: string): string {
    if (channel == CHANNEL_CONFIG.BR) { //巴西货币(雷尔)
        return changeNumByBRL(timeNum);
    } else if (channel == CHANNEL_CONFIG.ID) {  //印尼(卢比)
        return changeNumByID(timeNum);
    } else if (channel == CHANNEL_CONFIG.MX) {  //墨西哥(比索)
        return changeNumByMX(timeNum);
    } else if (channel == CHANNEL_CONFIG.PH) {  //菲律宾(比索)
        return changeNumByPHP(timeNum);
    } else if (channel == CHANNEL_CONFIG.VN) {  //越南(越南盾)
        return changeNumByVND(timeNum);
    } else if (channel == CHANNEL_CONFIG.TH) {  //泰国(泰铢)
        return changeNumByTHB(timeNum);
    } else if (channel == CHANNEL_CONFIG.EG) {  //埃及(埃镑)
        return changeNumByEGP(timeNum);
    } else if (channel == CHANNEL_CONFIG.CO) {  //哥伦比亚(比索)
        return changeNumByCOP(timeNum);
    } else if (channel == CHANNEL_CONFIG.IN) {  //印度(卢比)
        return changeNumByIN(timeNum);
    }
    return "0";
}

/**转换货币 巴西 雷亚尔 */
function changeMoneyByBRL(gold: number): string {
    let tempMoney = accDiv(gold, 100).toFixed(2);
    return changeNumByBRL(tempMoney);
}

/**转换货币 尼日利亚 奈拉*/
function changeMoneyByNGN(gold: number): string {
    let tempMoney: string = "" + gold;
    return changeNumByNGN(tempMoney);
}

/**转换货币 印尼 卢比*/
function changeMoneyByID(gold: number): string {
    let tempMoney = "" + accDiv(accMul(gold, 10), 1000);
    return changeNumByID(tempMoney);
}

/**转换货币 墨西哥 比索 */
function changeMoneyByMX(gold: number): string {
    let tempMoney = accDiv(gold, 100).toFixed(2);
    return changeNumByMX(tempMoney);
}

/**转换货币 菲律宾 比索 */
function changeMoneyByPHP(gold: number): string {
    let tempMoney = accDiv(gold, 100).toFixed(2);
    return changeNumByPHP(tempMoney);
}

/**转换货币 越南 越南盾 */
function changeMoneyByVND(gold: number): string {
    let tempMoney = "" + accDiv(gold, 100);
    return changeNumByVND(tempMoney);
}

/**转换货币 泰国 泰铢 */
function changeMoneyByTHB(gold: number): string {
    let tempMoney = accDiv(gold, 100).toFixed(2);
    return changeNumByTHB(tempMoney);
}

/**转换货币 埃及 埃镑 */
function changeMoneyByEGP(gold: number): string {
    let tempMoney = accDiv(gold, 100).toFixed(2);
    return changeNumByEGP(tempMoney);
}

/**转换货币 哥伦比亚 比索 */
function changeMoneyByCOP(gold: number): string {
    let tempMoney = accDiv(gold, 100).toFixed(2);
    return changeNumByCOP(tempMoney);

    // let tempMoney = ""+accDiv(gold, 100);
    // let m = tempMoney.replace(/\d+/, function (m: any) {
    //   return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    // });
    // return m + "K";
}

/**转换货币 印度 卢比 */
function changeMoneyByIN(gold: number): string {
    let tempMoney = accDiv(gold, 100).toFixed(2);
    return changeNumByIN(tempMoney);
}

/**转换数字 巴西 雷亚尔 */
function changeNumByBRL(num: string): string {
    let tempNum = num + "";
    tempNum = tempNum.replace(".", ",");
    return tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ".");
    });
}

/**转换数字 尼日利亚 奈拉*/
function changeNumByNGN(num: string): string {
    let tempNum = num + "";
    return tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
}

/**转换数字 印尼 卢比*/
function changeNumByID(num: string): string {
    let tempNum = num + "";
    let m = tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ".");
    });
    if (Number(tempNum) >= 100000000) {
        m = m.substring(0, m.length - 8) + "jt";
    } else if (Number(tempNum) >= 1000000) {
        m = m.substring(0, m.length - 4) + "rb";
    } else {
        m = m + "k";
    }
    return m;
}

/**转换数字 墨西哥 比索 */
function changeNumByMX(num: string): string {
    let tempNum = num + "";
    return tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
}

/**转换数字 菲律宾 比索 */
function changeNumByPHP(num: string): string {
    let tempNum = num + "";
    return tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
}

/**转换数字 越南 越南盾 */
function changeNumByVND(num: string): string {
    let tempNum = num + "";
    let m = tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
    return m + "K";
}

/**转换数字 泰国 泰铢 */
function changeNumByTHB(num: string): string {
    let tempNum = num + "";
    return tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
}

/**转换数字 埃及 埃镑 */
function changeNumByEGP(num: string): string {
    let tempNum = num + "";
    return tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
}

/**转换数字 哥伦比亚 比索 */
function changeNumByCOP(num: string): string {
    let tempNum = num + "";
    tempNum = tempNum.replace(".", ",");
    let m = tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ".");
    });
    return m + "K";

    // let tempMoney = ""+accDiv(gold, 100);
    // let m = tempMoney.replace(/\d+/, function (m: any) {
    //   return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    // });
    // return m + "K";
}

/**转换数字 印度 卢比 */
function changeNumByIN(num: string): string {
    let tempNum = num + "";
    return tempNum.replace(/\d+/, function (m: any) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
}

export default {
    changeMoney,
    getGold,
}